import Vue from 'vue'
import App from './App'
import router from './router'
import VueSession from 'vue-session'
import dev from './device'

Vue.use(VueSession)

import hint from './common.js'

Vue.prototype.autoDev = function() {
	dev.checkDevice({
		mobile: function() {
			console.log("识别为手机")
			location.replace('http://m.zanecon.cn')
			// location.replace('http://localhost:8080')

		},
		pc: function() {
			console.log("识别为PC")
			location.replace('http://zanecon.cn')
			// location.replace('http://localhost:8081')
		}
	})
}

Vue.config.productionTip = false

Vue.prototype.hint = hint
/*
# 测试环境 乐年本地地址
# VUE_APP_BASE_API = 'http://192.168.0.120:8080'
# VUE_APP_BASE_API = 'http://192.168.3.29:8080'
# 测试环境
VUE_APP_BASE_API = 'http://120.77.31.213:8080'
# 场外测试环境
# VUE_APP_BASE_API = 'http://47.112.174.103:8081'
# 测试环境
# VUE_APP_BASE_API = 'http://120.77.31.213:8080'
# 正式地址https
# VUE_APP_BASE_API = 'https://dp.zanecon.cn/api'
*/
// Vue.prototype.api = {
// 	dev: "http://120.77.31.213:8080", //开发模式
// 	online: "https://dp.zanecon.cn/api"
// }

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>',
	mounted() {
		window.addEventListener('load', () => {
			// 设置设备类型为PC端
			this.$session.set('devType', "Windows")
		})
	}
})

router.afterEach((to, from, next) => {
	// this.autoDev()
	// let devType = navigator.userAgent || ''
	// this.$session.set('devType',devType)
	window.scrollTo(0, 0);
})



// WEBPACK FOOTER //
// ./src/main.js